export default __webpack_public_path__ + "static/media/loginSvgSimer.c44bb053.svg";